<!-- <div class="row"> -->
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo'"
	[valueInput]="element.tipoScadenza?.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Adempimento'" [valueInput]="element.motivo?.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Priorit&agrave;'" [valueInput]="element.priorita?.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
	[labelInput]="'Data'" [valueInput]="element.dataScadenza"></div>
<!-- </div> -->